module.exports = (priceString) => {
    return parseFloat(priceString.replace('.', '').replace(',', '.'));
};
